"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconSocialInstagram = function SvgIconSocialInstagram(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "social instagram icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Social Instagram Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M42 31.754V16.246C42 10.595 37.403 6 31.754 6H16.246C10.595 6 6 10.595 6 16.246v15.508C6 37.403 10.595 42 16.246 42h15.508C37.403 42 42 37.403 42 31.754zm-3.085 0c0 3.947-3.214 7.16-7.161 7.16H16.246c-3.95 0-7.16-3.213-7.16-7.16V16.246a7.168 7.168 0 017.16-7.16h15.508c3.947 0 7.16 3.21 7.16 7.16v15.508zm-3.088-17.498c0-1.224-.99-2.218-2.215-2.218a2.216 2.216 0 000 4.433 2.216 2.216 0 002.215-2.215zM33.217 24c0-5.083-4.134-9.22-9.217-9.22s-9.22 4.137-9.22 9.22c0 5.083 4.137 9.217 9.22 9.217 5.083 0 9.217-4.134 9.217-9.217zm-3.085 0A6.138 6.138 0 0124 30.132 6.138 6.138 0 0117.868 24 6.138 6.138 0 0124 17.868 6.138 6.138 0 0130.132 24z"
  }));
};

var _default = SvgIconSocialInstagram;
exports.default = _default;